<template>
    <div>
        <div class="m_context" style="width:100%;">
            <div class='rowFr' style="width: 100%;">
                <div style='margin-left:24px;width: 100%;' class='rowa'>
                    <el-button type="primary" @click="open_push" size="" id="addTerm" icon="plus">{{ $t('app_add') }}
                    </el-button>
                    <el-button @click="addTer" type='primary' class=''>{{ $t('app_fileImport')
                    }}</el-button>
                </div>
            </div>
            <el-row style="margin-bottom: 20px;">
                <el-col :span="4" style="padding-left:4px;">
                    <div>
                        <el-input :placeholder="$t('ter.terminalNo')" v-model="select_forms.terminalNo"
                            @keyup.enter.native="get_device_lists">
                        </el-input>
                    </div>
                </el-col>
            </el-row>
            <el-table :data="arrdata" id="tp" border class='' style="width:100%;" ref="multipleTable"
                v-loading="loading" :element-loading-text="$t('lin_global.loading')">
                <el-table-column prop="terminalNo" :label="$t('ter.terminalNo')">
                </el-table-column>
                <el-table-column prop="mechName" :label="$t('ter.mechName')">
                </el-table-column>
                <el-table-column :label="$t('ter.status')" prop="status" align='center'>
                    <template scope="scope">
                        <span v-if="scope.row.status == 1">{{$t('ter.state1')}}</span>
                        <span v-else-if="scope.row.status == 2">{{$t('ter.state2')}}</span>
                        <span v-else>{{$t('ter.state3')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" :label="$t('ter.createTime')" width="">
                </el-table-column>
                <el-table-column align='center' :label="$t('lin_global.ope')" width="106">
                    <template scope="scope">
                        <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
                            <el-button type='text' @click='deleteApps(scope.row)'><i class="fa fa-trash"
                                    style="color:#FF4949"></i></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page_content">
                <el-pagination style='float:right;' @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="select_forms.page" :page-sizes="[10, 50, 100]"
                    :page-size="select_forms.rows" layout="total, sizes, prev, pager, next, jumper"
                    :total="totalRecords">
                </el-pagination>
            </div>
        </div>


        <el-dialog class='gDia' :title="$t('app_adddv')" v-model="show_push" @close='handleClose' size=''>
            <div v-loading='device_loading' id='' class='gBorder'>
                <el-row style=''>
                    <el-col :span="24">
                        <el-button type='primary' :disabled="select_device.length == 0" @click='bcPush'
                            class='gSgLeftBtn'>{{
                                $t('app_pushsldev') }}</el-button>
                    </el-col>
                </el-row>
                <el-row style=''>
                    <el-col :span="12" style="display: flex;align-items: center;">

                        <div class='gSideCtrl' style="margin-right: 8px;">
                            <el-input :placeholder="$t('app_start_no')" icon='search' :on-icon-click='get_device_list'
                                @keyup.enter.native='get_device_list' v-model='select_form.snBegin'></el-input>
                        </div>
                        <div class='gSideCtrl' style="margin-left: 0;margin-right: 0;">
                            ~
                        </div>
                        <div class='gSideCtrl'>
                            <el-input :placeholder="$t('app_end_no')" icon='search' :on-icon-click='get_device_list'
                                @keyup.enter.native='get_device_list' v-model='select_form.snEnd'></el-input>
                        </div>
                    </el-col>

                    <el-col v-show='true' :offset="0" :span="4">
                        <div class='gCtrl'>
                            <el-select @change='getCmDv' style='' v-model="select_form.terminal_status"
                                :placeholder="$t('app_status')">
                                <el-option v-for="item in sstatusAr" :key="item.vl" :label="item.lb" :value="item.vl">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>

                    <el-col v-show='true' :offset="0" :span="4">
                        <!-- <div class='gCtrl'><el-input  :placeholder="$t('app_adname')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div> -->
                        <div class='gCtrl'>
                            <MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
                        </div>
                    </el-col>
                    <el-col v-show='true' :span="4">
                        <div class='gSideCtrl'>
                            <el-input :placeholder="$t('app_terNo')" icon='search' :on-icon-click='get_device_list'
                                @keyup.enter.native='get_device_list' v-model='select_form.terminal_no'></el-input>
                        </div>
                    </el-col>
                </el-row>

                <el-table class='gTopMg' ref="multipleTable" id='dpTable' :data="deviceList" border
                    tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChangeDevice">
                    <el-table-column type="selection" align='center' width="55">
                    </el-table-column>
                    <el-table-column prop="terminalNo" align='center' :label="$t('app_terNo')" width="210">
                    </el-table-column>
                    <el-table-column align='center' prop="terminalName" :label="$t('app_terName')" width="210">
                    </el-table-column>
                    <el-table-column align=center prop='terminalStatus' :formatter="mkDvSt" :label="$t('app_status')"
                        width="150">
                    </el-table-column>
                    <el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width="210">
                    </el-table-column>

                    <el-table-column prop="operate" :label="$t('app_operate')" align='center' width='106'>
                        <template scope='scope'>
                            <el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
                                <el-button @click='pushed(scope.row)' type=text><i class="fa fa-upload" style=""></i>
                                </el-button>
                            </el-tooltip>

                        </template>
                    </el-table-column>
                </el-table>

                <div class="gPgDiv">

                    <el-pagination class='gPg' @current-change="pageSelectDevice" @size-change="pageSizedDevice"
                        :current-page="select_form.page" :page-sizes='[20, 100]' :page-size="select_form.rows"
                        layout="total, sizes, prev, pager, next, jumper" :total="deviceTotal">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>

        <el-dialog class='gDia' :title="$t('app_fipush')" v-model="pushImport" @close='closeImport'>
            <el-form model="" rules="">
                <el-form-item :label="$t('app_ulfile')" :label-width="formLabelWidth">

                    <el-upload class="upload-demo" ref="upload" name="fileUpload" :action="ulurl()"
                        :on-remove="beforeRemove" :before-upload="srcBefore" :on-success="srcSuccess"
                        :on-error='ulError' :file-list="fileList">
                        <el-button slot="trigger" size="small" type="primary">{{ $t('app_clickUpdate') }}</el-button>
                        <a :href="downTpl" style="margin-left:8px;margin-right:10px;">
                            <el-button type="success" size='small'>{{ $t('terminal.list.import_muban') }}</el-button>
                        </a>
                    </el-upload>

                </el-form-item>
                <el-form-item :label="$t('app_deviceNum')" :label-width="formLabelWidth">
                    {{ uldata ? uldata.terNums : 0 + $t('app_amechine') }}
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pushImport = false">{{ $t('app_cancel') }}</el-button>
                <el-button style="margin-left: 10px;" type="primary" @click="submitUpload">
                    {{ $t('app_srpush') }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import tagc from '@/components/global/tagc'
import axios from 'axios'
import {
    baseurl,
    url,
    focusEvent,
    urlAssets
} from '../../api/url'
import MechanismSelector from '@/components/global/mechanism_selector.vue'
export default {
    components: {
        MechanismSelector,
        tagc
    },
    data() {
        var that = this
        return {
            downTpl: `${urlAssets.prefix}tms-server-web/model/terminalNos.xlsx`,
            uldata: '',
            formLabelWidth: '28.5%',
            pushImport: false,
            fileList: [],
            mechanismData: {
                value: null,
                placeholder: that.$t('lin_global.place_areaid'),
                callback(value) {
                    that.mech = value
                    that.getCmDv()
                }
            },
            sstatusAr: [{
                vl: '',
                lb: this.$t('app_all')
            },
            {
                vl: '0',
                lb: this.$t('app_new')
            },
            {
                vl: '1',
                lb: this.$t('app_enable')
            }
            ],
            deviceTotal: 0,
            sstatus: {
                '0': this.$t('app_new'),
                '1': this.$t('app_enable')
            },
            deviceList: [],
            select_device: [],
            device_loading: false,
            show_push: false,
            select_form: {
                page: 1,
                rows: 20,
                areaid: "",
                snBegin: "",
                snEnd: "",
                terminal_status: "",
                terminal_no: ""
            },
            arrdata: [],
            loading: false,
            totalRecords: 0,
            select_forms: {
                page: 1,
                rows: 10,
                terminalNo: '',
            },
        }
    },
    methods: {
        beforeRemove() {
            this.fileList = []
            this.uldata = ''
        },
        // 上传前
        srcBefore(file) {
            if (this.uldata.fileNo) {
                // console.log('jll')
                return false
            }
            // window[this.$route.path] = 1
            var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
            const extension = testmsg === "xls";
            const extension2 = testmsg === "xlsx";
            if (!extension && !extension2) {
                this.$message({
                    message: this.$t("IncorrectaFormat"),
                    type: "warning",
                });
            }
            return extension || extension2;
        },
        // 上传成功
        srcSuccess(res, file) {
            window[this.$route.path] = ''
            //console.log(res, this.fileList)
            if (res.status === 200) {
                // this.fileList = [{
                // 	name: file.name
                // }]
                this.uldata = res.data
                // console.log('this.uldata', this.uldata)
                this.$message.success(res.message)
                // this.closeImport()
            } else {
                // this.srcList = []
                this.$message.error(res.message)
            }
        },
        // 上传失败
        ulError() {
            window[this.$route.path] = ''
        },
        ulurl() {
            var url = this.$fileExcelUlUrl + '?token=' + localStorage.user + '&language=' + localStorage.system_lang
            //  alert(url)
            return url
        },
        // 上传
        submitUpload() {
            // this.$refs.upload.submit()
            this.loading = true
            this.$terActImport(this.uldata.fileNo, (res) => {
                // console.log(res.data)
                this.loading = false
                if (res.status === 200) {
                    this.$message.success(res.message)
                } else {
                    this.$message.error(res.message)
                }
            }, () => {
                this.loading = false
            })
            this.fileList = []
            this.uldata = ''
            this.get_device_lists()
            this.pushImport = false
        },
        // 关闭文件导入窗口
        closeImport() {
            this.pushImport = false;
            this.fileList = []
            this.uldata = ''
        },
        addTer() {
            this.pushImport = true
        },
        deleteApps(obj) {
            this.$showConfirm(
                this.$t("app_tip"),
                this.$t("ter.msg"),
                this.$t("app_sure"),
                this.$t("app_cancel"),
                "warning",
                () => {
                    this.$delTerAct(
                        obj.id,
                        res => {
                            if (res.status === 200) {
                                this.$message.success(res.message);
                                this.get_device_lists();
                            } else {
                                this.$message.error(res.message);
                            }
                        },
                        ""
                    );
                },
                ""
            );
        },
        open_push() {
            this.show_push = true;
            this.getCmDv()
            // this.get_device_list()
        },
        mkDvSt(row) {
            return this.sstatus[row.terminalStatus]
        },
        handleSelectionChangeDevice(val) {
            this.select_device = val
        },
        get_device_list() {
            this.device_loading = true
            this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no,
                this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, (
                    res) => {
                this.device_loading = 0
                if (res.status === 200) {
                    //console.log(res.data)
                    this.deviceList = res.data
                    this.deviceTotal = res.total
                } else {
                    this.$message.error(res.message)
                }
            }, () => {
                // error
                this.device_loading = 0
            })
        },
        handleClose() {
            this.show_push = false;
            this.select_form = {
                page: 1,
                rows: 20,
                areaid: "",
                snBegin: "",
                snEnd: "",
                terminal_status: "",
                terminal_no: ""
            }
            var that = this;
            that.mech = ""
            this.mechanismData = {
                value: null,
                placeholder: that.$t('lin_global.place_areaid'),
                callback(value) {
                    that.mech = value
                    that.getCmDv()
                }
            }

        },
        // 批量推送
        bcPush() {
            var terminalNo_list = []
            // var mechId_list = []
            // var mechName_list = []
            this.select_device.forEach(obj => {
                terminalNo_list.push(obj.terminalNo)
                // mechId_list.push(obj.mechanismId)
                // mechName_list.push(obj.mechName)
            })

            var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length)

            this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning',
                () => {
                    let sub_form = {
                        terminalNo: String(terminalNo_list),
                        // mechId: String(mechId_list),
                        // mechName: String(mechName_list)
                    }
                    this.device_loading = true
                    this.$pushActivate(sub_form, (
                        res) => {
                        this.device_loading = false
                        if (res.status === 200) {
                            this.$message.success(res.message)
                            this.show_push = false;
                            this.get_device_lists()
                        } else {
                            this.$message.error(res.message)
                        }
                    }, () => {
                        // error
                        this.device_loading = false
                    })
                }, '')
        },
        // 单个推送
        pushed(row) {
            this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t(
                'app_sure'), this.$t(
                    'app_cancel'), 'warning', () => {
                        console.log(row)
                        let sub_form = {
                            terminalNo: row.terminalNo,
                            // mechId: row.mechanismId,
                            // mechName: row.mechName,
                        }
                        this.device_loading = true
                        this.$pushActivate(sub_form, (
                            res) => {
                            this.device_loading = false
                            if (res.status === 200) {
                                this.$message.success(res.message)
                                this.show_push = false;
                                this.get_device_lists()
                            } else {
                                this.$message.error(res.message)
                            }
                        }, () => {
                            // error
                            this.device_loading = false
                        })
                    }, '')
        },
        pageSizedDevice(vl) {
            this.select_form.rows = vl
            this.getCmDv()
        },
        pageSelectDevice(vl) {
            this.select_form.page = vl
            this.getCmDv()
        },
        getCmDv() {
            var _this = this
            var typeKey = 'terminalTypes'
            this.tqobj = {
                keys: [typeKey],
                callback: (data) => {
                    _this.cmtStatusArr = data[0]
                }
            }
            this.get_device_list()
        },



        handleSizeChange(vl) {
            this.select_forms.rows = vl
            this.get_device_lists()
        },
        handleCurrentChange(vl) {
            this.select_forms.page = vl
            this.get_device_lists()
        },
        get_device_lists() {
            this.loading = true
            this.$terminalActivate(this.select_forms.page, this.select_forms.rows, this.select_forms.terminalNo, '',
                (res) => {
                    this.loading = 0
                    if (res.status === 200) {
                        console.log(res.data)
                        this.arrdata = res.data
                        this.totalRecords = res.total
                    } else {
                        this.$message.error(res.message)
                    }
                }, () => {
                    // error
                    this.loading = 0
                })
        },
    },
    mounted() {
        this.get_device_lists()
    }
}
</script>
<style>
#tp td {
    cursor: pointer;
}
</style>
<style scoped>
.filename {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    display: block;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
}

.uploader input[type=file] {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    border: 0;
    z-index: 20;
    padding: 0;
    margin: 0;
    height: 30px;
    cursor: pointer;
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// devAct.vue?8f1701f2